import React from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { QuoteMarquee } from '../components/QuoteMarquee';
import { HowItWorks } from '../components/HowItWorks';
import { Features } from '../components/Features';
import { ChatShowcase } from '../components/ChatShowcase';
import { Salesforce } from '../components/Salesforce';
import { Privacy } from '../components/Privacy';
import { UseCases } from '../components/UseCases';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function Home() {
  return <>
      <Hero data-id="element-397" />
      <Problem data-id="element-398" />
      <QuoteMarquee data-id="element-399" />
      <HowItWorks data-id="element-400" />
      <Features data-id="element-401" />
      <ChatShowcase data-id="element-402" />
      <Salesforce data-id="element-403" />
      <Privacy data-id="element-404" />
      <UseCases data-id="element-405" />
      <FAQ data-id="element-406" />
      <FinalCTA data-id="element-407" />
    </>;
}